import { render } from "./AccordionElement.vue?vue&type=template&id=6c50c1aa&scoped=true"
import script from "./AccordionElement.vue?vue&type=script&lang=js"
export * from "./AccordionElement.vue?vue&type=script&lang=js"

import "./AccordionElement.vue?vue&type=style&index=0&id=6c50c1aa&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c50c1aa"]])

export default __exports__